

exports.__esModule = true;
exports.$GenericErrorRoute = undefined;

require('./directive');

var _squid = require('squid');

var $GenericErrorRoute = exports.$GenericErrorRoute = _squid.$ComponentRoute.extend('$GenericErrorRoute', {

    path: 'genericError',
    directive: 'xo-generic-error-page',
    titleContent: 'genericError.pleaseTryAgain',
    query: ['code'],
    // need to find these values
    trackingData: {
        fptiState: 'fatal_error',
        templateName: 'genericError.dust',
        pageGoal: 'Generic Error',
        pageQualifier: 'blockNonDomesticShipping',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-generic-error',
                'pagename2': '%::fullpage-generic-error:member:hermes:',
                'version': 'member:%:'
            }
        }
    },

    auth: false,

    children: []
});

angular.value("$GenericErrorRoute", $GenericErrorRoute);
_squid.$ComponentRoute;


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-generic-error/route.js
 ** module id = 208
 ** module chunks = 1
 **/